import React from 'react';

import { cn } from './cn';

export interface LinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  variant?: 'default' | 'muted' | 'ghost';
  disabled?: boolean;
  /** Render as button-like element (no href) */
  asButton?: boolean;
}

const variantClasses: Record<string, string> = {
  default: 'text-info-500 hover:text-info-600 hover:underline',
  muted: 'text-gray-600 hover:text-gray-900 font-medium no-underline',
  ghost: 'text-gray-500 hover:text-gray-700 no-underline',
};

export const Link = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ children, variant = 'default', disabled, className, asButton, onClick, ...props }, ref) => {
    const classes = cn(
      'inline-flex items-center gap-1 text-sm transition-colors duration-200 cursor-pointer',
      variantClasses[variant],
      disabled && 'opacity-50 pointer-events-none',
      className
    );

    if (asButton || !props.href) {
      return (
        <button className={cn(classes, 'bg-transparent border-none p-0')} onClick={onClick as any} disabled={disabled}>
          {children}
        </button>
      );
    }

    return (
      <a ref={ref} className={classes} onClick={onClick} {...props}>
        {children}
      </a>
    );
  }
);
Link.displayName = 'Link';
